import { TASK_TYPE } from 'utils/constants'

const {
  Bug,
  Task,
  Improvement,
  NewFunctionality,
  Release,
  Guarantee,
  Research,
} = TASK_TYPE

export const CHECKLIST_ALLOWED_TASK_TYPES = [
  Bug,
  Task,
  Improvement,
  NewFunctionality,
  Release,
  Guarantee,
  Research,
]

export const TEMPLATE_ALLOWED_TASK_TYPES = [
  Bug,
  Task,
  Improvement,
  NewFunctionality,
  Release,
  Guarantee,
  Research,
]

export const isChecklistAllowedTaskType = (taskTypeId) =>
  CHECKLIST_ALLOWED_TASK_TYPES.includes(taskTypeId)

export const isTemplateAllowedTaskType = (taskTypeId) =>
  TEMPLATE_ALLOWED_TASK_TYPES.includes(taskTypeId)
